import { observable, action } from "mobx"
import utils from '../utils'
const { FE } = utils

class CityInfo {
  constructor(){
    this.info.cityId = +FE.Utils.getCityId() || 110100
    this.info.provinceId = parseInt(this.info.cityId/1e4,0)*1e4

    window.city[this.info.provinceId].map((i,n) => {
      if (i.CityId === this.info.cityId) {
        this.info.cityName = i.CityName
      }
    })

    window.province[0].map((i,n) => {
      if (i.ProvinceId === this.info.provinceId) {
        this.info.provinceName = i.ProvinceName
      }
    })
  }

  @observable
  isShow = false

  @observable
  info = {}

  @action.bound
  show() {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    document.body.style.cssText += 'position:fixed;width:100%;left:0;top:-' + scrollTop + 'px;'
    
    this.isShow = true
  }

  @action.bound
  hide() {
    let body = document.body
    body.style.position = 'static'
    let top = body.style.top
    document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top,0)
    body.style.top = ''

    this.isShow = false
  }

  @action.bound
  changeCity(newCity) {
    this.info = newCity
  }
}

export default new CityInfo()


// WEBPACK FOOTER //
// ./src/stores/CityInfo.js